{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-25T14:04:09.219Z","source":"place-details"}